module.exports = __webpack_public_path__ + "img/ValidatorEquation1.7f83ca67.png";